import { CommonModule } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { CenterChildDto } from "@malirang/api-client";
import { ContactPipe, Icon } from "@malirang/front-share";

@Component({
    selector: "app-document-select-child-card",
    templateUrl: "./document-select-child-card.html",
    styleUrls: ["./document-select-child-card.css"],
    imports: [CommonModule, Icon, ContactPipe],
})
export class DocumentSelectChildCard {
    item = input.required<CenterChildDto>();
    child = computed(() => this.item()?.child);
    tickets = computed(
        () => this.item()?.enrollments?.flatMap((e) => e.tickets) || [],
    );
}
